import axios from 'axios'
import { ManualShipmentRuleApplyRequest } from '@/components/manual-shipment/manual-shipment.dto'
import {
    CommonPortionFamilyTreeRequest, CommonSampleFamilyTreeRequest,
    CommonSubportionFamilyTreeRequest
} from '@/api/resources/common/shared/models/common.models'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ManualShipmentRuleApplierService {
    async applyOverSamples(request: ManualShipmentRuleApplyRequest<CommonSampleFamilyTreeRequest>, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/applyOverSamples`, request)
        return response.data
    }
    async applyOverPortions(request: ManualShipmentRuleApplyRequest<CommonPortionFamilyTreeRequest>, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/applyOverPortions`, request)
        return response.data
    }
    async applyOverSubportions(request: ManualShipmentRuleApplyRequest<CommonSubportionFamilyTreeRequest>, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.put<EntityIdentifierWithErrorResponse[]>(`/shipments/laboratory/${laboratoryId}/manualShipmentRules/applyOverSubportions`, request)
        return response.data
    }
}

export const manualShipmentRuleApplierService = new ManualShipmentRuleApplierService()
